export const handleNavigation = (navigate, path, newTab = false) => {
    if (newTab) {
        window.open(path, '_blank');
    } else {
        navigate(path);
        window.scrollTo(0, 0);
    }
};
